import React from "react";

import { GestureResponderEvent, TouchableOpacity } from "react-native";

import EditText from "./FormEdit";
import {
  Container,
  Wrapper,
  ItemContainer,
  ItemWrapper,
  ItemIcon,
  ItemLabelWrapper,
  ItemLabel,
  ItemRight,
  ItemRightText,
  Edit,
  ItemDescription,
  ChildWrapper,
  RadioChecked,
  RadioUnchecked,
  ChildDivider,
} from "./FormRadioGroupStyled";

interface Props {
  children: any;
  hasMargin?: boolean;
}

const FormRadioGroup = ({ children, hasMargin = true }: Props) => {
  const childs = React.Children.toArray(children);

  return (
    <Container hasMargin={hasMargin}>
      {childs
        .filter((child) => child.type === Item)
        .map((child, i) => {
          const last = i === childs.length - 1;

          return (
            <Wrapper key={i}>
              {React.cloneElement(child, {
                last: child.props.last ? child.props.last : last,
              })}
            </Wrapper>
          );
        })}
    </Container>
  );
};

export default FormRadioGroup;

interface ItemProps {
  children?: any;
  right?: React.ReactNode;

  testID?: string;
  label: string;
  editLabel?: string;
  description?: React.ReactNode;
  last?: boolean;
  primary?: boolean;
  selected?: boolean;
  labelNumberOfLines?: number | null;
  disableOpacity?: boolean;
  alignTop?: boolean;
  disabled?: boolean;

  onSelect?: (event: GestureResponderEvent) => void;
  onEdit?: (event: GestureResponderEvent) => void;
}

const Item = ({
  testID,
  label,
  editLabel = "Editar",
  description,
  last,
  primary = false,
  selected,
  children,
  right,
  // Use 0 or null if you want to avoid truncation
  // of text shown below the option to be selected.
  labelNumberOfLines = 3,
  disableOpacity = false,
  alignTop = false,
  onSelect,
  onEdit,
  disabled = false,
}: ItemProps) => {
  // default TouchabilityIpacity is 0.2
  const opacity = disableOpacity ? 1 : 0.2;

  function onSelectUnlessDisabled(e) {
    if (!disabled) {
      onSelect?.(e);
    }
  }

  return (
    <>
      <TouchableOpacity
        testID={testID}
        onPress={onSelectUnlessDisabled}
        activeOpacity={opacity}
        disabled={disabled}
      >
        <ItemContainer
          last={last}
          primary={primary}
          selected={selected}
          hasChildren={children}
        >
          <ItemWrapper alignTop={alignTop}>
            {onSelect && (
              <ItemIcon>
                {selected ? (
                  <RadioChecked />
                ) : (
                  <RadioUnchecked disabled={disabled} />
                )}
              </ItemIcon>
            )}
            <ItemLabelWrapper>
              <ItemLabel
                numberOfLines={labelNumberOfLines}
                ellipsizeMode="tail"
                disabled={disabled}
              >
                {label}
              </ItemLabel>

              {description && typeof description === "string" ? (
                <ItemDescription>{description}</ItemDescription>
              ) : (
                description
              )}
            </ItemLabelWrapper>
          </ItemWrapper>
          {right && (
            <ItemRight>
              <ItemRightText>{right}</ItemRightText>
            </ItemRight>
          )}
          {onEdit && (
            <ItemRight>
              <Edit onPress={onEdit}>
                <EditText>{editLabel}</EditText>
              </Edit>
            </ItemRight>
          )}
        </ItemContainer>
      </TouchableOpacity>
      {selected && children && (
        <>
          <ChildWrapper primary={primary} last={last}>
            {children}
          </ChildWrapper>
          {!primary && !last && <ChildDivider />}
        </>
      )}
    </>
  );
};

FormRadioGroup.Item = Item;
